import { DynamicTimetableCellTypeDTO } from '@model/dynamicTimeTable/DynamicTimetableCellTypeDTO';
import { t } from '@hclinear/hc-linear-react';

export const getElementDisplay = (cellType: DynamicTimetableCellTypeDTO) =>
  t(`dynamic-timetable.cell.${cellType.toString().toLowerCase()}`);
